
import { Options, prop, setup, Vue } from 'vue-class-component';

class Props {
  title = prop({
    type: String,
    default: "Title"
  })
}

@Options({})
export default class ZhTab extends Vue.with(Props) {

  info = setup(() => {
    return {}
  })
}
